import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgBoosterDimension = {
  height: 16,
  width: 16,
  viewBox: '0 0 16 16',
};
export const SvgBooster = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#booster-clip)">
      <path
        d="M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8Z"
        fill="#EEC880"
      />
      <path
        d="M6.63435 12.4625L10.5869 7.71662H8.03686L8.54686 3.66493L4.96267 8.84996H7.14435L6.63435 12.4625ZM5.60018 13.6667L6.16685 9.69997H3.3335L8.43353 2.33325H9.56687L9.0002 6.86661H12.4002L6.73352 13.6667H5.60018Z"
        fill="#191A1A"
      />
    </g>
    <defs>
      <clipPath id="booster-clip">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
